import css from 'styled-jsx/css'
import { colors } from 'theme'

export  default css`
  .divider {
    display: inline-block;
    border-bottom: 1px solid ${colors.border};
    margin: 1rem 0;
    width: 100%;
  }

  .divider.dashed {
    border-style: dashed;
  }

  .divider.normal {
    border-color: ${colors.border};
  }
  .divider.gray {
    border-color: ${colors.gray};
  }
`